<template>
    <div class="confetti-left">
        <ConfettiExplosion
            :particle-count="100"
            :duration="4000"
            :force="0.6"
            :stage-height="1400"
            :z-index="zIndex"
        />
    </div>
    <div class="confetti-right">
        <ConfettiExplosion
            :particle-count="100"
            :duration="4000"
            :force="0.6"
            :stage-height="1400"
            :z-index="zIndex"
        />
    </div>
</template>

<script>
import ConfettiExplosion from '@/student/components/Confetti/ConfettiExplosion.vue';

export default {
    components: {
        ConfettiExplosion,
    },
    props: {
        zIndex: {
            type: Number,
            default: null,
        },
    },
};
</script>

<style lang="scss" scoped>
.confetti-left {
    position: absolute;
    top: 0;
    left: 0;
}

.confetti-right {
    position: absolute;
    top: 0;
    right: 0;
}
</style>
